import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Input,
  TextArea,
  DatePicker,
  DatePickerMobile,
  SelectOptions,
  Image,
} from "components";
import {
  formatDollarsToCents,
  priceToDollars,
  getSortedDataToDisplay,
} from "helpers";
import * as styles from "./editStore.styles";
import { Button, LineButton, FlexRow, FlexColumn, FlexRight } from "appStyles";
import { css } from "react-emotion";
import NumberFormat from "react-number-format";
import Switch from "@material-ui/core/Switch";
import Modal from "@material-ui/core/Modal";
import DoneIcon from "@material-ui/icons/Done";
import UpdateIcon from "@material-ui/icons/Update";
import CreateIcon from "@material-ui/icons/Create";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import CategoryGroup from "./CategoryGroup";
import NewReleasesOutlinedIcon from "@material-ui/icons/NewReleasesOutlined";
import { toast } from "react-toastify";
import StyledToast from "../../../Tools/StyledToast";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import CategoryGroupOrdering from "./CategoryGroupOrdering";

import Alert from "@material-ui/lab/Alert";
import { isAssetError } from "next/dist/client/route-loader";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  position: relative;
  border-radius: 5px;
  margin-bottom: 3em;
  overflow-y: auto;
  height: 98%;
`;

const mobileContainer = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  position: relative;
  border-radius: 5px;
  margin-bottom: 3em;
  overflow-y: auto;
  height: 100%;
`;

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  icon: {
    backgroundColor: "rgb(83,95,103)",
    borderRadius: "100px",
    padding: "5px",
    color: "white",
    boxShadow: "3px 3px 13px rgb(120 120 120 / 50%)",
  },
}));

const Store = (props) => {
  const {
    id,
    price,
    finePrint,
    maxPurchasesTotal,
    maxPurchasesPerUser,
    usePurchasedItemsBy,
    numberOfTotalPurchases,
    imageUrl,
    title,
    description,
    expiration,
    retired,
    importantNote,
    isLive,
    isPublic,
    postOrderNotes,
    punchcardId,
    additionalOptions,
    templateId,
  } = props.storeItem;

  const { isMobileAdminView, accessToken } = props;

  // if (isMobileAdminView) {
  //   console.log("loading mobile view....");
  // }

  // console.dir(additionalOptions);
  console.dir(props.storeItem);

  const putStoreItem = () => {
    props.putStoreItem(props.storeItem, accessToken).then((storeItem) => {
      if (storeItem.error != undefined) {
        notify("There was an issue updating your store item.");
      }
    });
    notify("update");
    props.updateActiveEditor(null);
  };

  const getStoreName = (id) => {
    const { getStorePages } = props;
    const pageName = getStorePages().filter((page) => page.id === id)[0]
      .pageName;

    if (pageName) {
      return " for " + pageName + "!";
    } else {
      return ".";
    }
  };

  const notify = (action, id) => {
    switch (action) {
      case "create":
        toast(
          StyledToast({
            message:
              "🤗 The store item " + title + " was created" + getStoreName(id),
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "update":
        toast(
          StyledToast({
            message: "👏 The store item " + title + " was updated!",
            confirm: true,
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      case "delete":
        toast(
          StyledToast({
            message: "❌ The store item " + title + " was deleted!",
          }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      default:
        toast.error(action, {
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
    }
  };

  const [isNewStoreItem, setIsNewStoreItem] = useState(id === "newStoreItem");
  const [scrollToTop, setScrollToTop] = useState(false);
  const [showReorderGroupsModal, setShowReorderGroupsModal] = useState(false);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [showItemOptions, setShowItemOptions] = useState(false);
  const [showPunchardOptions, setShowPunchcardOptions] = useState(
    punchcardId > 0 || punchcardId
  );

  const [showFooter, setShowFooter] = useState(true);

  const [isClone, setIsClone] = useState(false);
  const [originalStoreId, setOriginalStoreId] = useState(templateId);

  const [error, setError] = useState("");

  const [tempId, incrementTempId] = useState(1);

  const [categoryObject, setCategoryObject] = useState(null);
  var activeElement = document.activeElement;
  var inputs = ["input", "select", "textarea"];

  const classes = useStyles();
  const linkPunchcardText = `Each time a customer purchases this item they will receive a stamp on the selected punch card. To setup a punchcard, you must add a “Punchcard” page to your app.`;

  const titleText = `Use this if you require your customer to select additional options for
  your product. For example, if you sell your product in 3 sizes, start
  off by creating a group titled “Select Size”. Then, add the options
  small / medium / large. Or, if you're selling a burrito, create a group
  titled “Select Meat”, then add options chicken / steak / shrimp.`;

  const isEditable =
    numberOfTotalPurchases < 1 ||
    isNewStoreItem ||
    numberOfTotalPurchases === null;

  const createTempId = () => {
    incrementTempId(tempId + 1);
    return tempId;
  };

  const isExpired = (storeItem) => {
    if (storeItem.expiration) {
      var expirationDate = new Date(storeItem.expiration);
      var now = new Date();
      if (expirationDate.getTime() < now.getTime()) {
        return true;
      }
    }
    return false;
  };
  const togglePunchcardOptions = () => {
    if (showPunchardOptions) {
      setShowPunchcardOptions(false);
      props.updateStoreItem({
        ...props.storeItem,
        punchcardId: -1,
      });
    } else {
      setShowPunchcardOptions(true);
    }
  };

  const toggleAdvancedOptions = () => {
    setShowAdvancedOptions(!showAdvancedOptions);
  };

  const getFooterStyle = () => {
    if (!isMobileAdminView || showFooter) return "block";
    return "none";
  };

  const renderFooterRow = () => {
    return (
      <div
        className={
          isMobileAdminView
            ? styles.MobileSectionContainer
            : styles.SectionContainer
        }
        style={{
          position: "sticky",
          bottom: isMobileAdminView ? "0px" : "5px",
          padding: "0.5em 1.5em",
          border: "3px solid #bee2e2",
          borderRadius: "0px",
          zIndex: "10",
          display: getFooterStyle(),
        }}
      >
        <FlexRow
          style={{
            justifyContent: "space-between",
            height: "auto",
          }}
        >
          {!retired && !isNewStoreItem && !isExpired(props.storeItem) && (
            <div>
              <LineButton
                color="#F17F7F"
                onClick={deleteStoreItem}
                className={styles.boldButton}
                style={{ width: "auto", marginRight: "20px" }}
              >
                Delete
              </LineButton>
              <LineButton
                onClick={createClone}
                className={styles.boldButton}
                color="#89D2D3"
                style={{ width: "auto" }}
              >
                Copy
              </LineButton>
            </div>
          )}
          {(!isNewStoreItem && retired) || isExpired(props.storeItem) ? (
            <div>
              <LineButton
                onClick={createClone}
                className={styles.boldButton}
                color="#89D2D3"
                style={{ width: "auto" }}
              >
                Copy
              </LineButton>
            </div>
          ) : null}
          {isNewStoreItem && (
            <div>
              <Button
                onClick={deleteStoreItem}
                background="#F17F7F"
                className={styles.buttonStyle}
              >
                <CancelIcon style={{ marginRight: "5px" }}></CancelIcon>
                Cancel
              </Button>
            </div>
          )}

          {error && <Alert severity="error">{error}</Alert>}
          {!isNewStoreItem && !retired && (
            <Button
              onClick={putStoreItem}
              background="#89D2D3"
              disable={!isEditable}
              className={styles.buttonStyle}
            >
              <UpdateIcon style={{ marginRight: "5px" }}></UpdateIcon>
              Update
            </Button>
          )}

          {isNewStoreItem && (
            <Button
              onClick={createStoreItem}
              background="#89D2D3"
              className={styles.buttonStyle}
            >
              <CreateIcon style={{ marginRight: "5px" }}></CreateIcon>
              Create
            </Button>
          )}
        </FlexRow>
      </div>
    );
  };

  const renderAdvancedOptionsModal = () => {
    if (!showAdvancedOptions) return null;
    return (
      <Modal
        open={showAdvancedOptions}
        onClose={toggleAdvancedOptions}
        style={{
          top: "25%",
          width: isMobileAdminView ? "100%" : "50%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          style={{
            height: "auto",
            backgroundColor: "#fff",
            padding: "1em",
            color: "black",
          }}
        >
          <styles.H2 style={{ margin: "0px" }}>Advanced Options</styles.H2>
          <TextArea
            width="100%"
            height="5rem"
            placeholder="Post Order Message to Send to Customer (Optional)"
            text={postOrderNotes}
            onChange={update("postOrderNotes")}
          />

          <FlexRight style={{ alignSelf: "flex-end", marginTop: "20px" }}>
            <Button
              onClick={toggleAdvancedOptions}
              background="#89D2D3"
              className={styles.buttonStyle}
            >
              <DoneIcon style={{ marginRight: "5px" }}></DoneIcon>
              Done
            </Button>
          </FlexRight>
        </div>
      </Modal>
    );
  };

  const createStoreItem = () => {
    if (props.storeItem.title) {
      // console.log("creating store item: ");
      // console.dir(props.storeItem);
      if (props.storeItem.price === null) {
        props.storeItem.price = 0;
      }
      props.storeItem.additionalOptions.forEach((group) => {
        // console.log(group.id);
        delete group.id;
        group.additionalOptionsItems.forEach((item) => {
          delete item.id;
        });
        // console.log(group.id);
      });
      props
        .createStoreItem(
          {
            appId: props.appId,
            templateId: parseInt(props.templateId),
            ...props.storeItem,
          },
          isClone && originalStoreId != templateId,
          accessToken
        )
        .then((storeItem) => {
          if (storeItem.error != undefined) {
            setError("There was an issue creating your store item.");
            window.setTimeout(() => {
              setError("");
            }, 2000);
          } else {
            notify("create", storeItem.templateId);
          }
        });

      props.updateActiveEditor(null);
    } else {
      setError("Item name cannot be empty");
      window.setTimeout(() => {
        setError("");
      }, 2000);
    }
  };
  const scrollTo = (ref) => {
    if (ref && isNewStoreItem && scrollToTop /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setScrollToTop(false);
  };

  const createClone = () => {
    props.addTempStoreCloneItem(props.storeItem);
    props.updateActiveEditor("newStoreItem");
    setIsNewStoreItem(true);
    setIsClone(true);
    setScrollToTop(true);
  };

  const deleteStoreItem = () => {
    if (isNewStoreItem) {
      props.removeStoreItem(props.storeItem);
      props.deleteTempStoreItem(props.storeItem);
    } else {
      props.deleteStoreItem(props.storeItem, accessToken);
      notify("delete");
    }
    props.updateActiveEditor(null);
  };

  const update = (field) => (value) => {
    if (field === "maxPurchasesTotal" || field === "maxPurchasesPerUser") {
      if (value === null || value === 0) {
        value = null;
      } else {
        value = parseInt(value);
      }
    }
    if (field === "price") {
      value = formatDollarsToCents(value["value"]);
    }
    // console.log("***** updating!!!!");
    // console.log("updating field: " + field + " with value: " + value);
    props.updateStoreItem({
      ...props.storeItem,
      [field]: value,
    });
  };
  const updateGroups = (groupsObject, id) => {
    // console.log("***** updating!!!!");
    // console.log("updating group object: ");
    // console.dir(groupsObject);
    props.updateStoreItem({
      ...props.storeItem,
      additionalOptions: groupsObject,
    });
  };

  const handleChange = (event) => {
    // console.log(event);
    props.updateStoreItem({
      ...props.storeItem,
      [event.target.name]: event.target.checked,
    });
  };

  const permaDisable = !isEditable || retired;

  const renderHeaderRow = () => {
    return (
      <FlexRow style={{ height: "auto", marginBottom: "20px" }}>
        {isNewStoreItem && (
          <styles.H2 style={{ margin: "0px" }}>New Store Item</styles.H2>
        )}
        {!isNewStoreItem && !isEditable && !retired && (
          <styles.H2 style={{ margin: "0px", color: "#89D2D3" }}>
            This item has been purchased {numberOfTotalPurchases} times and is
            no longer editable. Click “Copy” below to clone this item.
          </styles.H2>
        )}
        {!isNewStoreItem && isEditable && !retired ? (
          <styles.H2 style={{ margin: "0px" }}>Edit Store Item</styles.H2>
        ) : null}

        {retired ? (
          <styles.H2 style={{ margin: "0px", color: "#89D2D3" }}>
            This item has been deleted and is no longer editable. Click “ Copy”
            below to clone this item.
          </styles.H2>
        ) : null}
        <span></span>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: isMobileAdminView ? "15px" : "0px",
          }}
        >
          <span
            style={{
              cursor: "pointer",
              fontSize: "12px",
              lineHeight: "14px",
              color: "#8C8C8C",
              textDecoration: "underline",
            }}
            onClick={toggleAdvancedOptions}
          >
            Advanced Options
          </span>
          {!isMobileAdminView && (
            <span
              style={{
                cursor: "pointer",
                fontSize: "0.9375rem",
                lineHeight: "14px",
                color: "black",
                marginLeft: "10px",
              }}
              onClick={() => props.updateActiveEditor(null)}
            >
              <CloseIcon fontSize={"large"}></CloseIcon>
            </span>
          )}
        </div>
      </FlexRow>
    );
  };

  const toggleItemOptions = (group) => {
    if (group) {
      const { isOptional } = group;
      const isMandatory = !isOptional;
      setCategoryObject({ ...group, isMandatory: isMandatory });
    } else {
      setCategoryObject({
        id: "NewGroup",
        title: "",
        subtitle: "",
        minOptions: -1,
        maxOptions: -1,
        isOptional: true,
        isMandatory: false,
        additionalOptionsItems: [],
      });
    }
    setShowItemOptions(!showItemOptions);
  };

  const editGroup = (group) => {
    // console.log("====>>>> ready to edit group");
    // console.dir(group);

    toggleItemOptions(group);
  };

  const renderItemOptionsModal = () => {
    if (!showItemOptions) return null;

    return (
      <Modal
        open={showItemOptions}
        onClose={toggleItemOptions}
        disableBackdropClick={true}
        style={{
          top: isMobileAdminView ? "1%" : "2%",
          width: isMobileAdminView ? "100%" : "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <CategoryGroup
          closeModal={toggleItemOptions}
          categoryObjectsArray={additionalOptions}
          storeItemId={id}
          updateGroups={updateGroups}
          group={categoryObject}
          createTempId={createTempId}
          isMobileAdminView={isMobileAdminView}
          accessToken={accessToken}
          {...props}
        />
      </Modal>
    );
  };

  const renderOptionsItems = (items) => {
    if (!items || items.length === 0) return null;

    const displayItems = getSortedDataToDisplay(items);

    // console.log("store component rendering items");
    // console.dir(displayItems);
    return (
      <div style={{ margin: "10px 0px" }}>
        {displayItems.map((item, idx) => {
          // console.dir(item);
          if (item.retired) return null;
          return (
            <div className={styles.itemOptionRow} key={idx}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "0.9375rem",
                }}
              >
                <p>{item.name}</p>
                {item.price != 0 && <p>+{priceToDollars(item.price)}</p>}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const toggleReorderGroupsModal = () => {
    setShowReorderGroupsModal(!showReorderGroupsModal);
  };

  const renderReorderGroupsModal = () => {
    if (!showReorderGroupsModal) return null;

    return (
      <Modal
        open={showReorderGroupsModal}
        disableAutoFocus={true}
        // disableBackdropClick={isNewStoreItem}
        onClose={toggleReorderGroupsModal}
        style={{
          margin: "auto",
          width: isMobileAdminView ? "100%" : "35%",
          top: isMobileAdminView ? "1%" : "10%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "560px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={toggleReorderGroupsModal}
          >
            <CloseIcon></CloseIcon>
          </span>
          <CategoryGroupOrdering
            groups={additionalOptions}
            closeModal={toggleReorderGroupsModal}
            updateGroups={updateGroups}
            storeItemId={id}
            group={categoryObject}
            accessToken={accessToken}
            {...props}
          />
        </div>
      </Modal>
    );
  };

  const getLiveGroupsCount = () => {
    let liveGroupsCount = 0;
    additionalOptions.map((group) => {
      if (!group.retired) liveGroupsCount += 1;
    });
    return liveGroupsCount;
  };

  const renderGroupButtons = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent:
            additionalOptions.length > 1 && getLiveGroupsCount() >= 2
              ? "space-between"
              : "center",
        }}
      >
        <Button
          onClick={() => toggleItemOptions(null)}
          background="#89D2D3"
          className={styles.buttonStyle}
        >
          <CreateIcon style={{ marginRight: "5px" }}></CreateIcon>
          Create New Selections Group
        </Button>
        {additionalOptions.length > 1 && getLiveGroupsCount() >= 2 && (
          <Button
            background="#89D2D3"
            className={styles.buttonStyle}
            onClick={toggleReorderGroupsModal}
          >
            <ShuffleIcon style={{ marginRight: "5px" }}></ShuffleIcon>
            Reorder Groups
          </Button>
        )}
      </div>
    );
  };

  const renderGroups = () => {
    if (!additionalOptions) return null;

    let nullRankFlag = false;
    // go through all groups and add their title to array based on order recieved
    const displayGroups = [];
    additionalOptions.map((group) => {
      if (group.sortOrder && !group.retired) {
        return (displayGroups[group.sortOrder - 1] = {
          id: group.id,
          ...group,
        });
      } else {
        nullRankFlag = true;
      }
    });

    if (nullRankFlag) {
      additionalOptions.reverse().map((group) => {
        if (!group.sortOrder && !group.retired) {
          return displayGroups.push({
            ...group,
          });
        }
      });
    }

    return (
      <FlexRow
        style={{
          justifyContent: "space-around",
          marginTop: "40px",
          display: "flex",
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        {displayGroups.map((group) => {
          if (group.retired) return null;
          return (
            <div
              style={{
                borderRadius: "5px",
                boxShadow: "3px 3px 13px rgb(120 120 120 / 50%)",
                flex: "1 1 30%",
                margin: "20px",
                maxWidth: "325px",
                minWidth: isMobileAdminView ? "280px" : "300px",
              }}
              key={group.id}
            >
              <div
                style={{
                  backgroundColor: "#89D2D3",
                  display: "flex",
                  padding: "10px 10px",
                  borderRadius: "5px 5px 0px 0px",
                  color: "white",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <a
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => editGroup(group)}
                >
                  Edit Group
                </a>
              </div>
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "10px 0px",
                  }}
                >
                  <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                    {group.title}
                  </p>
                  {!group.isOptional && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <NewReleasesOutlinedIcon
                        color="primary"
                        fontSize="small"
                        style={{ marginRight: "5px" }}
                      />
                      <span style={{ fontSize: "10px" }}>Required</span>
                    </div>
                  )}
                </div>
                <div>
                  <p style={{ fontSize: "12px", color: "gray" }}>
                    {group.subtitle}
                  </p>
                </div>
                {renderOptionsItems(group.additionalOptionsItems)}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    background="#89D2D3"
                    className={styles.buttonStyle}
                    onClick={() => editGroup(group)}
                  >
                    + Add Selection
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </FlexRow>
    );
  };

  const renderItemOptionsContainer = () => {
    return (
      <div
        className={
          isMobileAdminView
            ? styles.MobileSectionContainer
            : styles.SectionContainer
        }
      >
        <div style={{ marginBottom: "40px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ fontSize: "24px", letterSpacing: "2px" }}>
              Item Options
            </p>
          </div>

          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Alert severity="info">
              Use this if you require your customer to select additional options
              for your product. For example, if you sell your product in 3
              sizes, start off by creating a group titled “Select Size”. Then,
              add the options small / medium / large. Or, if you're selling a
              burrito, create a group titled “Select Meat”, then add options
              chicken / steak / shrimp.
            </Alert>
          </div>
          <hr
            style={{
              borderTop: "1px solid #dfe5e6",
              margin: "20px 0px",
              width: "100%",
            }}
          />
        </div>
        {renderItemOptionsModal()}
        {renderGroupButtons()}
        {renderReorderGroupsModal()}

        {/* <div>
          <Button
            onClick={createStoreItem}
            background="#89D2D3"
            className={styles.buttonStyle}
          >
            <AutorenewIcon style={{ marginRight: "5px" }}></AutorenewIcon>
            Use Existing Selections Group
          </Button>
        </div> */}
        {renderGroups()}
      </div>
    );
  };

  const renderLinkToPunchcardContainer = () => {
    const hasPunchcardPage = props.hasPunchcardPage;
    const punchcards = props.punchcards;
    const options = [];
    Object.keys(punchcards).forEach((id) => {
      if (!punchcards[id].retired) {
        options.push({ value: id, label: punchcards[id].title });
      }
    });
    if (!hasPunchcardPage || options.length == 0) {
      return null;
    }

    // console.dir(options);
    return (
      <div
        className={
          isMobileAdminView
            ? styles.MobileSectionContainer
            : styles.SectionContainer
        }
      >
        <div style={{ marginBottom: "40px" }}>
          <p style={{ fontSize: "24px", letterSpacing: "2px" }}>
            Link to Punchcard
          </p>
          <div
            style={{
              marginTop: "10px",
            }}
          >
            <Alert severity="info">
              Each time a customer purchases this item they will receive a stamp
              on the selected punch card. To setup a punchcard, you must add a
              “Punchcard” page to your app.
            </Alert>
          </div>
          <hr
            style={{
              borderTop: "1px solid #dfe5e6",
              margin: "20px 0px",
              width: "100%",
            }}
          />
        </div>
        <div
          style={{
            alignSelf: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              alignSelf: "flex-start",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                margin: "13px 15px 15px 0px",
              }}
            >
              Link to Punchcard
            </p>
            <Switch
              checked={showPunchardOptions}
              onChange={togglePunchcardOptions}
              color="primary"
              name="punchardId"
              inputProps={{ "aria-label": "primary checkbox" }}
              disabled={!isEditable}
            />
          </div>
          <div
            style={{
              display: showPunchardOptions ? "flex" : "none",
              alignSelf: "flex-start",
            }}
          >
            {" "}
            {options && (
              <SelectOptions
                width={isMobileAdminView ? "280px" : "350px"}
                options={options}
                setValue={update("punchcardId")}
                value={punchcardId ? punchcardId.toString() : punchcardId}
                className={styles.selectStyle}
                isDisabled={!isEditable}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderItemLimitationsContainer = () => {
    return (
      <div
        className={
          isMobileAdminView
            ? styles.MobileSectionContainer
            : styles.SectionContainer
        }
      >
        <div style={{ marginBottom: "40px" }}>
          <p style={{ fontSize: "24px", letterSpacing: "2px" }}>
            Item Limitations
          </p>
          <hr
            style={{
              borderTop: "1px solid #dfe5e6",
              margin: "20px 0px",
              width: "100%",
            }}
          />
        </div>
        {isMobileAdminView ? (
          <DatePickerMobile
            datePickerProps={{
              showTimeSelect: true,
              timeFormat: "hh:mm a",
              timeIntervals: 10,
              timeCaption: "time",
              dateFormat: "MM/dd/yyyy hh:mm a",
              style: {
                marginLeft: "0px",
                marginTop: "10px",
                marginBottom: "20px",
                innerWidth: isMobileAdminView ? "100%" : "200px",
                innerBackgroundPosition: "175px center",
              },
            }}
            isExpirationDate={true}
            title="Expiration Date:"
            selected={expiration}
            onChange={update("expiration")}
            isMobileAdminView={isMobileAdminView}
          />
        ) : (
          <DatePicker
            datePickerProps={{
              showTimeSelect: true,
              timeFormat: "hh:mm a",
              timeIntervals: 10,
              timeCaption: "time",
              dateFormat: "MM/dd/yyyy hh:mm a",
              style: {
                marginLeft: "0px",
                marginTop: "10px",
                marginBottom: "20px",
                innerWidth: isMobileAdminView ? "100%" : "200px",
                innerBackgroundPosition: "175px center",
              },
            }}
            isExpirationDate={true}
            title="Expiration Date:"
            selected={expiration}
            onChange={update("expiration")}
          />
        )}

        <Input
          field="Max Purchases Per User (Optional)"
          type="number"
          min={0}
          defaultValue={maxPurchasesPerUser}
          onChange={update("maxPurchasesPerUser")}
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          width={isMobileAdminView ? " 100%" : "30%"}
          marginBottom={"20px"}
          onFocus={onFocus}
          onBlur={onBlur}
        />

        <br />

        <Input
          field="Max Purchases Overall (Optional)"
          type="number"
          min={0}
          defaultValue={maxPurchasesTotal}
          onChange={update("maxPurchasesTotal")}
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          width={isMobileAdminView ? " 100%" : "30%"}
          marginBottom={"20px"}
          onFocus={onFocus}
          onBlur={onBlur}
        />

        <br />
      </div>
    );
  };

  const getStorePageOptions = () => {
    const { getStorePages } = props;
    let options = [];
    getStorePages().forEach((page) => {
      options.push({ value: page.id, label: page.pageName });
    });
    return options;
  };

  const onFocus = () => {
    // console.log("input focused");
    setShowFooter(false);
  };

  const onBlur = () => {
    // console.log("input blurred");
    setShowFooter(true);
  };

  const renderBasicInfoContainer = () => {
    return (
      <div
        className={
          isMobileAdminView
            ? styles.MobileSectionContainer
            : styles.SectionContainer
        }
      >
        <div style={{ marginBottom: "40px" }}>
          <p style={{ fontSize: "24px", letterSpacing: "2px" }}>Basic Info</p>
          <hr
            style={{
              borderTop: "1px solid #dfe5e6",
              margin: "20px 0px",
              width: "100%",
            }}
          />
        </div>
        {isClone && (
          <div style={{ marginBottom: "15px", alignSelf: "flex-start" }}>
            <p style={{ marginBottom: "10px" }}>Select Store</p>
            <SelectOptions
              width={isMobileAdminView ? "100%" : "370px"}
              options={getStorePageOptions()}
              setValue={update("templateId")}
              value={templateId}
              className={styles.selectStyle}
            />
          </div>
        )}
        <div style={{ marginBottom: "15px", alignSelf: "flex-start" }}>
          <Image
            title="Image Upload"
            options={{ croppingAspectRatio: null }}
            imageUrl={imageUrl}
            uploadImage={update("imageUrl")}
            isMobileAdminView={isMobileAdminView}
            titleWidth={"fit-content"}
          />
        </div>

        <br />
        <Input
          field="Item Name (Required)"
          validateInput="true"
          defaultValue={title}
          onChange={update("title")}
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          width={isMobileAdminView ? "100%" : "30%"}
          marginBottom={"20px"}
          onFocus={onFocus}
          onBlur={onBlur}
        />

        <br />
        <NumberFormat
          placeholder="Starting Price (Required)"
          thousandSeparator={true}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
          allowNegative={false}
          allowLeadingZeros={false}
          defaultValue={price ? priceToDollars(price) : null}
          onValueChange={update("price")}
          className={
            isMobileAdminView ? styles.mobileInputStyle : styles.inputStyle
          }
          disabled={permaDisable}
          style={{
            backgroundColor: permaDisable ? "lightgrey" : "white",
            color: permaDisable ? "gray" : "rgb(31, 55, 71)",
            marginBottom: "20px",
          }}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <br />
        <TextArea
          width={isMobileAdminView ? "100%" : "50%"}
          height="5rem"
          placeholder="Description (Optional)"
          text={description}
          onChange={update("description")}
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          marginBottom={"20px"}
          marginTop={"0px"}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <br />
        <TextArea
          width={isMobileAdminView ? "100%" : "50%"}
          height="5rem"
          placeholder="Fine Print (Optional)"
          text={finePrint}
          onChange={update("finePrint")}
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          marginBottom={"20px"}
          marginTop={"0px"}
          onFocus={onFocus}
          onBlur={onBlur}
        />

        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            alignSelf: "flex-start",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              margin: "15px 0px",
              marginRight: "15px",
            }}
          >
            Currently Available
          </p>
          <Switch
            checked={isLive}
            onChange={handleChange}
            color="primary"
            name="isLive"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            alignSelf: "flex-start",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              margin: "15px 0px",
              marginRight: "15px",
            }}
          >
            Publicly Display on Mobile360 Marketplace
          </p>
          <Switch
            checked={isPublic}
            onChange={handleChange}
            color="primary"
            name="isPublic"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        </div>
        <br />

        <TextArea
          width={isMobileAdminView ? "100%" : "50%"}
          height={isMobileAdminView ? "7rem" : "5rem"}
          placeholder="Additional Note to Customer (Optional). Examples - ”Contains nuts”, “Pick up within 24 hours”, “Must use by June 15”"
          text={importantNote}
          onChange={update("importantNote")}
          maxLength="255"
          disabled={permaDisable}
          textColor={permaDisable ? "gray" : "rgb(31, 55, 71)"}
          background={permaDisable ? "lightgrey" : "white"}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <br />
      </div>
    );
  };

  return (
    <div className={isMobileAdminView ? mobileContainer : container}>
      <a ref={scrollTo}></a>
      <div
        className={
          isMobileAdminView ? styles.mobileFormStyle : styles.formStyle
        }
      >
        {isMobileAdminView && (
          <styles.FloatingIconTopRight
            onClick={() => props.updateActiveEditor(null)}
          >
            <CloseIcon className={classes.icon} fontSize="large"></CloseIcon>
          </styles.FloatingIconTopRight>
        )}
        {renderAdvancedOptionsModal()}
        {renderHeaderRow()}
        <FlexRow style={{ alignItems: "flex-start", height: "auto" }}>
          <FlexColumn width="100%" style={{ alignItems: "flex-start" }}>
            {renderBasicInfoContainer()}
            {renderItemLimitationsContainer()}
            {renderLinkToPunchcardContainer()}
            {renderItemOptionsContainer()}
          </FlexColumn>
        </FlexRow>
        {renderFooterRow()}
      </div>
    </div>
  );
};

Store.propTypes = {
  storeItem: PropTypes.object,
  putStoreItem: PropTypes.func,
  deleteStoreItem: PropTypes.func,
  updateStoreItem: PropTypes.func,
};

export default Store;
